// extracted by mini-css-extract-plugin
module.exports = {"answer":"Answer_answer__Pmwu_","answer__input":"Answer_answer__input__qwjez","answer__button":"Answer_answer__button__pdGTq"};